export default __webpack_public_path__ + "static/blog-generic-cover-ae6029b6f67a51a956e21e0ee8f8f890.png";